module.exports = __webpack_public_path__ + "img/work_grey.1bcecfa4.png";